<app-card class="top-card">
  @if (title()) {
    <div class="headline">{{ title() }}</div>
  }
  @for (filter of filters(); track filter.name) {
    @if (filter.type === "range") {
      <app-range-form
        [ranges]="ranges"
        [min]="filter.values.min"
        [max]="filter.values.max"
        (outputUpdate)="onRangeChange($event)"
        picker
      />
    }
    @if (filter.type === "enumeration") {
      <app-enumeration-filter [filter]="filter" (filterUpdate)="onEnumerationChange($event)" />
    }
  }
</app-card>
<div class="graphs">
  @if (graphs(); as graphData) {
    @if (graphData.length === 0) {
      <app-card class="loader" i18n>Loading data...</app-card>
    } @else {
      <app-metrics-graph-group [graphs]="graphData" [filters]="filters()" />
    }
  } @else {
    <app-card class="loader" i18n>No data matching the selected filters</app-card>
  }
</div>
